<template>
    <div>
        <password-meter :password="password" v-if="password.length > 0" />
        <div v-if="passwordIsGreat" class="py-2 text-slate-500 dark:text-slate-400 text-xs">
            Good to go, your password is great!
        </div>
        <ul v-if="password.length > 0 && !passwordIsGreat" class="pt-1">
            <li class="text-slate-800 dark:text-slate-100 text-xs">Your password must contain:</li>
            <li class="flex items-center gap-1">
                <i
                    class="fas fa-check fa-fw text-base text-emerald-500"
                    v-if="passwordCheckList.hasLength"
                ></i>
                <i
                    class="fal fa-times fa-fw text-base text-red-500"
                    v-if="!passwordCheckList.hasLength"
                ></i>
                <span class="text-xs">At least 9 characters</span>
            </li>
            <li class="flex items-center gap-1">
                <i
                    class="fas fa-check fa-fw text-base text-emerald-500"
                    v-if="passwordCheckList.hasAlpha"
                ></i>
                <i
                    class="fal fa-times fa-fw text-base text-red-500"
                    v-if="!passwordCheckList.hasAlpha"
                ></i>
                <span class="text-xs">Numbers (0-9)</span>
            </li>
            <li class="flex items-center gap-1">
                <i
                    class="fas fa-check fa-fw text-base text-emerald-500"
                    v-if="passwordCheckList.hasLowerCase"
                ></i>
                <i
                    class="fal fa-times fa-fw text-base text-red-500"
                    v-if="!passwordCheckList.hasLowerCase"
                ></i>
                <span class="text-xs">Lower case letters (a-z)</span>
            </li>
            <li class="flex items-center gap-1">
                <i
                    class="fas fa-check fa-fw text-base text-emerald-500"
                    v-if="passwordCheckList.hasUpperCase"
                ></i>
                <i
                    class="fal fa-times fa-fw text-base text-red-500"
                    v-if="!passwordCheckList.hasUpperCase"
                ></i>
                <span class="text-xs">Upper case letters (A-Z)</span>
            </li>
            <li class="flex items-center gap-1">
                <i
                    class="fas fa-check fa-fw text-base text-emerald-500"
                    v-if="passwordCheckList.hasSpecial"
                ></i>
                <i
                    class="fal fa-times fa-fw text-base text-red-500"
                    v-if="!passwordCheckList.hasSpecial"
                ></i>
                <span class="text-xs">
                    Special characters (e.g. ! @ # $ % ^ & * ( ) _ + - [ ] . ?)
                </span>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue';
import PasswordMeter from 'vue-simple-password-meter';

const props = defineProps(['password']);
const emit = defineEmits(['isValidPassword']);

const passwordCheckList = ref({
    hasAlpha: false,
    hasLength: false,
    hasCase: false,
    hasSpecial: false,
});

const passwordIsGreat = computed(() => {
    return (
        passwordCheckList.value.hasAlpha &&
        passwordCheckList.value.hasLength &&
        passwordCheckList.value.hasCase &&
        passwordCheckList.value.hasUpperCase &&
        passwordCheckList.value.hasLowerCase &&
        passwordCheckList.value.hasSpecial
    );
});

watch(
    () => props.password,
    (val) => {
        const lowerCase = /[a-z]/;
        const upperCase = /[A-Z]/;
        const specialChars = /[!@#$%^&*()_+\-\[\].?~]/;
        let hasAlpha = /\d/.test(props.password);
        let hasSpecial = specialChars.test(props.password);
        let hasLowerCase = lowerCase.test(props.password);
        let hasUpperCase = upperCase.test(props.password);
        let hasMixedCase = hasLowerCase && hasUpperCase;
        passwordCheckList.value.hasLength =
            props.password.length > 8 ? true : false;
        passwordCheckList.value.hasAlpha = hasAlpha ? true : false;
        passwordCheckList.value.hasCase = hasMixedCase ? true : false;
        passwordCheckList.value.hasUpperCase = hasUpperCase ? true : false;
        passwordCheckList.value.hasLowerCase = hasLowerCase ? true : false;
        passwordCheckList.value.hasSpecial = hasSpecial ? true : false;

        emit('isValidPassword', passwordIsGreat.value);
    }
);
</script>
